import type { enWidget } from '../en/widget.js';

export const deWidget: Record<keyof typeof enWidget, string> = {
  'w.document_title': 'Tisch reservieren bei {restaurant}',
  'w.reserve': 'Tisch reservieren',
  'w.no_restaurant': 'Es ist kein Restaurant eingerichtet.',
  'w.code_not_found': 'Wir konnten diese Reservierungsnummer nicht finden.',
  'w.taken': 'Diese Zeit wurde leider gerade vergeben.',
  'w.offer_stale': 'Dieser Termin ist nicht mehr aktuell. Die Suche wird wiederholt…',
  'w.hold_expired': 'Ihre Zeitreservierung ist abgelaufen. Bitte wählen Sie erneut eine Zeit.',
  'w.hold_expired_confirm':
    'Ihre Zeitreservierung ist abgelaufen, bevor Sie bestätigt haben. Bitte wählen Sie erneut eine Zeit.',
  'w.call_for_party':
    'Die Online-Buchung für diese Gruppengröße ist derzeit nicht möglich. Bitte rufen Sie das Restaurant an.',
  'w.card_load_failed':
    'Das Kartenformular konnte nicht geladen werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'w.card_not_ready': 'Das Kartenformular ist noch nicht bereit. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
  'w.card_failed': 'Ihre Karte konnte nicht verifiziert werden.',
  'w.cancel_confirm': 'Diese Reservierung stornieren?',
  'w.cancel_fee': 'Gemäß den Stornierungsbedingungen kann eine Gebühr anfallen.',
  'w.online_off': 'Online-Reservierungen sind derzeit nicht möglich. Bitte rufen Sie das Restaurant an.',
  'w.online_off_waitlist':
    'Online-Reservierungen sind nicht möglich; bitte melden Sie sich im Restaurant für die Warteliste oder rufen Sie uns an.',
  'w.find_aria': 'Tisch finden',
  'w.date': 'Datum',
  'w.time': 'Uhrzeit',
  'w.party_size': 'Personenzahl',
  'w.find': 'Tisch finden',
  'w.searching': 'Suche läuft…',
  'w.nearby': 'Zeiten in der Nähe',
  'w.available_times': 'Verfügbare Zeiten',
  'w.day_aria': 'Tag',
  'w.times_one': '{n} Zeit',
  'w.times_other': '{n} Zeiten',
  'w.none': 'keine',
  'w.no_tables': 'Keine Tische für {party} am {date}',
  'w.try_other_day': 'Bitte wählen Sie oben einen anderen Tag.',
  'w.card_required': 'Karte erforderlich',
  'w.unavailable': 'nicht verfügbar',
  'w.pay.legend': 'Zahlung',
  'w.pay.deposit':
    'Es wird jetzt eine Anzahlung von <strong>{amount}</strong> erhoben, die bei rechtzeitiger Stornierung erstattet wird.',
  'w.pay.card':
    'Wir hinterlegen Ihre Karte, um die Reservierung abzusichern. <strong>Es wird nichts abgebucht</strong>, außer die Stornierungsbedingungen greifen (bis zu {amount}).',
  'w.pay.test': 'Testmodus: Es wird keine Karte benötigt und es wird kein Geld bewegt.',
  'w.pay.card_aria': 'Kartendaten',
  'w.held_for': 'Reserviert für {timer}',
  'w.table_for': 'Tisch für {n}',
  'w.change_time': 'Zeit ändern',
  'w.more_time': 'Mehr Zeit nötig?',
  'w.policy.title': 'Stornierungsbedingungen',
  'w.policy.deposit': 'Anzahlung',
  'w.policy.card': 'Kartengarantie',
  'w.policy.per_guest': 'pro Person',
  'w.policy.flat': 'pauschal',
  'w.policy.detail': '{kind}: {amount} {per}; kostenlose Stornierung bis {hours} Stunden vorher.',
  'w.seating': 'Sitzbereich',
  'w.first_name': 'Vorname',
  'w.last_name': 'Nachname',
  'w.email': 'E-Mail',
  'w.phone': 'Mobilnummer',
  'w.occasion': 'Anlass (optional)',
  'w.request': 'Besondere Wünsche (optional)',
  'w.sms': 'Updates zu dieser Reservierung per SMS senden',
  'w.marketing': 'Neuigkeiten und Angebote per E-Mail senden',
  'w.confirming': 'Wird bestätigt…',
  'w.confirm': 'Reservierung bestätigen',
  'w.pay_confirm': '{amount} zahlen und bestätigen',
  'w.booked': 'Ihre Reservierung ist bestätigt',
  'w.cancelled': 'Reservierung storniert',
  'w.code': 'Reservierungsnummer',
  'w.row.restaurant': 'Restaurant',
  'w.row.when': 'Wann',
  'w.row.party': 'Personen',
  'w.row.name': 'Name',
  'w.row.status': 'Status',
  'w.cancel': 'Reservierung stornieren',
  'w.new': 'Weitere Reservierung vornehmen',
  'w.menus': 'Speisekarten',
  'w.menu.show': 'Speisekarten ansehen',
  'w.menu.hide': 'Speisekarten ausblenden',
  'w.menu.price': '{price}',
  'w.event.title': 'Private Veranstaltungen',
  'w.event.intro': 'Sie planen eine Feier oder ein Firmenessen? Senden Sie uns eine Anfrage, wir melden uns mit einem Angebot.',
  'w.event.open': 'Veranstaltung anfragen',
  'w.event.room': 'Raum',
  'w.event.any': 'Keine Präferenz',
  'w.event.guests': 'Gäste',
  'w.event.date': 'Datum',
  'w.event.from': 'Von',
  'w.event.to': 'Bis',
  'w.event.name': 'Ihr Name',
  'w.event.company': 'Firma (optional)',
  'w.event.email': 'E-Mail',
  'w.event.phone': 'Telefon (optional)',
  'w.event.notes': 'Erzählen Sie uns vom Anlass',
  'w.event.send': 'Anfrage senden',
  'w.event.thanks': 'Vielen Dank. Wir haben Ihre Anfrage und melden uns per E-Mail.',
  'w.alert.title': 'Benachrichtigen',
  'w.alert.intro': 'Nichts frei? Hinterlassen Sie Ihre E-Mail-Adresse, und wir sagen Ihnen Bescheid, wenn an diesem Tag ein Tisch frei wird.',
  'w.alert.from': 'Von',
  'w.alert.to': 'Bis',
  'w.alert.send': 'Benachrichtigen, wenn ein Tisch frei wird',
  'w.alert.thanks': 'Erledigt. Wir schreiben Ihnen, sobald ein Tisch frei wird.',
  'w.code.link': 'Ich habe einen Zugangscode',
  'w.code.label': 'Zugangscode',
  'w.code.apply': 'Anwenden',
  'w.code.bad': 'Dieser Code ist nicht gültig.',
  'w.member': 'Nur für Mitglieder',
  'w.member_error': 'Dieses Angebot ist für eingeladene Gäste. Bitte verwenden Sie die E-Mail-Adresse, die das Restaurant kennt.',
  'w.event.taken': 'dann schon belegt',
  'w.contact': 'Kontakt',
  'w.about': 'Über das Restaurant',
  'w.terms': 'Ich akzeptiere die Bedingungen.',
  'w.exp.title': 'Besondere Angebote',
  'w.exp.any': 'Ein Tisch, ohne besonderes Angebot',
  'w.exp.price': '{price} pro Person',
  'w.wl.title': 'Warteliste',
  'w.wl.join': 'Auf die Warteliste',
  'w.wl.offer': 'Zu diesen Zeiten ist nichts frei. Sie können sich auf die Warteliste setzen lassen; wir schreiben Ihnen, sobald ein Tisch bereit ist.',
  'w.wl.closed': 'Die Warteliste ist im Moment nicht geöffnet.',
  'w.wl.name': 'Ihr Name',
  'w.wl.sms': 'Schreiben Sie mir, wenn mein Tisch bereit ist',
  'w.wl.submit': 'Auf die Warteliste setzen',
  'w.wl.waiting': 'Sie stehen auf der Warteliste',
  'w.wl.ready': 'Ihr Tisch ist bereit. Bitte kommen Sie zum Empfang.',
  'w.wl.done': 'Vielen Dank. Sie stehen nicht mehr auf der Warteliste.',
  'w.wl.quote': 'Geschätzte Wartezeit',
  'w.wl.waited': 'Bisher gewartet',
  'w.wl.ahead': 'Gruppen vor Ihnen',
  'w.wl.minutes': '{n} Min.',
  'w.wl.keep_open': 'Lassen Sie diese Seite geöffnet. Sie aktualisiert sich selbst.',
};
